"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _languagesImporterWebpack = _interopRequireDefault(require("./modules/languages-importer-webpack"));

var _i18nConfigGenerator = _interopRequireDefault(require("./modules/i18n-config-generator.js"));

var _extractValidatationCopies = _interopRequireDefault(require("./modules/extract-validatation-copies.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const defaultOptions = {
  extractValidations: true
};

const swordVueLanguagesConfigs = (context, preferredLanguage, fallbackLanguage, options = defaultOptions) => {
  const languages = (0, _languagesImporterWebpack.default)(context);

  if (options.extractValidations) {
    (0, _extractValidatationCopies.default)(languages);
  }

  const vueI18nOptions = (0, _i18nConfigGenerator.default)(languages, preferredLanguage, fallbackLanguage);
  return {
    languages,
    i18nOptions: vueI18nOptions
  };
};

var _default = swordVueLanguagesConfigs;
exports.default = _default;